"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MarketingModuleFaq = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Container = require("../../components/Container/Container");

var _Column = require("../../components/Column/Column");

var _Row = require("../../components/Row/Row");

var _Box = require("../../components/Box/Box");

var _Button = _interopRequireDefault(require("../../components/Button/Button"));

var _FaqGroup = require("../../components/FaqGroup/FaqGroup");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var MarketingModuleFaq = function MarketingModuleFaq(_ref) {
  var title = _ref.title,
      mainContent = _ref.mainContent,
      cta = _ref.cta,
      faq1 = _ref.faq1,
      faq2 = _ref.faq2,
      faq3 = _ref.faq3,
      faq4 = _ref.faq4,
      spaceDefaultEnabled = _ref.spaceDefaultEnabled,
      props = _objectWithoutProperties(_ref, ["title", "mainContent", "cta", "faq1", "faq2", "faq3", "faq4", "spaceDefaultEnabled"]);

  return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_Container.Container, _extends({
    my: spaceDefaultEnabled ? [5, 5, 5, 6, 6, 6] : []
  }, props), _react.default.createElement(_Row.Row, {
    flexWrap: true
  }, _react.default.createElement(_Column.Column, {
    column: 0,
    columnXs: 1,
    columnSm: 0,
    columnMd: 1
  }), _react.default.createElement(_Column.Column, {
    column: 8,
    columnXs: 5,
    columnSm: 4,
    columnLg: 3
  }, mainContent && mainContent), _react.default.createElement(_Column.Column, {
    column: 4,
    columnXs: 6,
    columnSm: 0
  }), _react.default.createElement(_Column.Column, {
    column: 2,
    columnXs: 3,
    columnSm: 0,
    columnLg: 1
  }), _react.default.createElement(_Column.Column, {
    column: 10,
    columnXs: 8,
    columnSm: 8,
    columnMd: 7,
    columnLg: 6
  }, _react.default.createElement(_Box.Box, {
    mb: 4
  }, props.faqSingle ? props.faqSingle : _react.default.createElement(_FaqGroup.FaqGroup, {
    title: title
  }, faq1 && faq1, faq2 && faq2, faq3 && faq3, faq4 && faq4)), cta && cta))));
};

exports.MarketingModuleFaq = MarketingModuleFaq;
MarketingModuleFaq.propTypes = {
  title: _propTypes.default.string,
  mainContent: _propTypes.default.object,
  cta: _propTypes.default.object,
  faq1: _propTypes.default.object,
  faq2: _propTypes.default.object,
  faq3: _propTypes.default.object,
  faq4: _propTypes.default.object,
  faqSingle: _propTypes.default.object,
  spaceDefaultEnabled: _propTypes.default.bool
};
MarketingModuleFaq.defaultProps = {
  title: 'Frequently Asked Questions',
  spaceDefaultEnabled: false
};